<template>
  <div class="apply">
    <div class="main-width">
      <div class="banner apply m_t20">
        <div class="header flex flex-justify item-center">
          <div class="title font-bold color_black font-20">在线访谈</div>
        </div>
      </div>
      <el-table
        :data="tableData"
        :show-header="false"
        class="m_t10 lack_box"
        style="width: 100%"
        @row-click="(row, column, e) => toDetail(row, column, e)"
      >
        <template slot="empty">
          <div class="lack m_t30">
            <img style="height: 100px" src="@images/center/recom.png" alt="" />
            <div style="text-align: center; margin-top: 20px">无匹配政策</div>
          </div>
        </template>
        <el-table-column label="">
          <template slot-scope="scope">
            <div class="table-item">
              <div class="item-left">
                <img :src="scope.row.withPicturesUrl" alt="" />
              </div>
              <div class="item-right">
                <h3>{{ scope.row.title }}</h3>
                <p>
                  <span>访谈嘉宾：</span>
                  <span>{{ scope.row.ftjb }}</span>
                </p>
                <p>
                  <span>访谈时间：</span>
                  <span>{{ scope.row.releaseDate }}</span>
                </p>
                <p>
                  <span>访谈摘要：</span>
                  <span>{{ scope.row.ftzy }}</span>
                </p>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="center-block tc m_t45">
        <Pagination
          :total="total"
          :pages="pages"
          :currentPageSize="size"
          :currentPage="current"
          @currentChange="currentChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "@components/base/pagination/PcmPagination.vue";
import { list_policy } from "@/api/policy";
export default {
  name: "online",
  components: {
    Pagination,
  },
  data() {
    return {
      tableData: [],
      total: 0,
      pages: 0,
      current: 1,
      size: 15,
      loading: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      let options = {
        pageNumber: this.current,
        pageSize: this.size,
        order: "desc",
        orderBy: "create_time",
        unscrambleType: "在线访谈",
        addressCode: this.$route.query.AddressCode,
      };
      list_policy(options)
        .then(({ data }) => {
          let { code, result } = data;
          if (code === 200) {
            const { totalElements, content, totalPages } = result;
            this.tableData = content.map((item) => {
              item = item.content;
              return item;
            });
            this.total = totalElements;
            this.pages = totalPages;
          }
        })
        .finally(() => (this.loading = false));
    },
    currentChange(params) {
      this.current = params;
      this.getData(1);
    },
    toDetail(row, column, e) {
      window.open(row.originalAddress);
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-table th.el-table__cell.is-leaf {
  border: none;
  .cell {
    padding: 0;
  }
}
::v-deep {
  .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
    background: none;
    cursor: default;
  }
}
.apply {
  margin: 10px auto 0;
  .banner {
    .header {
      padding: 20px 0;
      border-bottom: 1px solid #bfbfbf;
    }
  }
  .table-item {
    display: flex;
    width: 1200px;
    cursor: pointer;
    .item-left {
      width: 300px;
      height: 170px;
      img {
        width: 300px;
        height: 170px;
        display: block;
      }
    }
    .item-right {
      flex: 1;
      white-space: pre-wrap;
      padding-left: 30px;
      h3 {
        color: #407c98;
        margin: 12px 0px 2px;
      }
      p {
        margin: 12px 0;
        white-space: pre-wrap;
        width: 96%;
      }
    }
  }
}
</style>
